import {AbstractSubscriber, IFacet, IResult} from ".";

export abstract class AbstractSearchCore {
  subscribers: AbstractSubscriber[] = [];
  groupId: string;
  config: any;
  constructor(groupId: string, config?:any) {
    this.config = config;
    this.groupId = groupId;
  }
  public getGroupId(): string {
    return this.groupId;
  };

  public async subscribe(subscriber: AbstractSubscriber): Promise<void> {
    if (this.subscribers.indexOf(subscriber) == -1) {
      this.subscribers.push(subscriber);
      subscriber.attached(this);
    }

  };

  public unsubscribe(subscriber: AbstractSubscriber): void {
    const index = this.subscribers.indexOf(subscriber);
    if (index !== -1) {
      subscriber.detaching();
      this.subscribers.splice(index, 1);
    }
  };

  public getSubscribers():AbstractSubscriber[] {
    return this.subscribers;
  };
  public countSubscribers():number {
    return this.subscribers.length;
  };

  public destroy():void {
    this.subscribers.map((value:AbstractSubscriber) => {
      value.detaching();
    });
    this.subscribers = [];
  }

  abstract loadFacetFilters(): Promise<any>
  abstract executeSearch(query: string): Promise<IResult>;
  abstract setFacet(facet:IFacet): Promise<IResult>;
  abstract setQuery(query:string): void;
  abstract getFacets(): IFacet[];
  abstract setPage(pageNumber: number): Promise<IResult>;
}
